export const ICONS = {
  DEFAULT:
    'https://cdn-imgix-open.headout.com/itinerary/map/default-pin-v2.svg',
  START: 'https://cdn-imgix-open.headout.com/itinerary/map/start-pin.svg',
  END: 'https://cdn-imgix-open.headout.com/itinerary/map/end-pin.svg',
  PASS_BY:
    'https://cdn-imgix-open.headout.com/itinerary/map/pass-by-landmark.svg',
};
